import { PrestationCancel } from "./PrestationCancel";
import React, { useContext } from "react";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { PrestationFollow } from "./PrestationFollow";
import { modalsByContext } from "./modals";
import { PrestationEditAdmin } from "./PrestationEditAdmin";
import { InstitutionNewAddress } from "./InstitutionNewAddress";
import { InstitutionSelectAddress } from "./InstitutionSelectAddress";
import { PrestationControl } from "./PrestationControl";
import { PrestationGrouped } from "./PrestationGrouped";
import { SelectResponsable } from "./SelectResponsable";
import {BillCamtLinking} from "./BillCamtLinking";
import { UsersDuplicator } from "./UsersDuplicator";

export const ModalsDynamic = props => {
  const { modals } = useContext(ModalContext);

  const models = [
    <PrestationCancel
      key={modalsByContext.PrestationCancel}
      defaultOpen={true}
    />,
    <PrestationFollow
      key={modalsByContext.PrestationFollow}
      defaultOpen={true}
    />,
    <PrestationEditAdmin
      key={modalsByContext.PrestationEditAdmin}
      defaultOpen={true}
    />,
    <InstitutionNewAddress
      key={modalsByContext.InstitutionNewAddress}
      defaultOpen={true}
    />,
    <InstitutionSelectAddress
      key={modalsByContext.InstitutionSelectAddress}
      defaultOpen={true}
    />,
    <PrestationControl
      key={modalsByContext.PrestationControl}
      defaultOpen={true}
    />,
    <BillCamtLinking
      key={modalsByContext.BillCamtLinking}
      defaultOpen={true}
    />,
    <PrestationGrouped
      key={modalsByContext.PrestationGrouped}
      defaultOpen={true}
    />,
    <SelectResponsable
      key={modalsByContext.SelectResponsable}
      defaultOpen={true}
    />,
    <UsersDuplicator
      key={modalsByContext.UsersDuplicator}
      defaultOpen={true}
    />,
  ];
  return models.filter(e => modals.includes(e.key));
};
